import { createSlice } from "@reduxjs/toolkit";
import { donationNumbersAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const donationNumbersSlice = createSlice({
  name: "donationNumbers",
  initialState: data,
  reducers: {
    donationNumbersSlice(state) {
      state.isLoading = false;
    },
    donationNumbersSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    donationNumbersSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    donationNumbersSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const donationNumbersHandler = () => async (dispatch: any) => {
  try {
    dispatch(donationNumbersAction.donationNumbersSlice());
    const response: any = await donationNumbersAPI();
    dispatch(donationNumbersAction.donationNumbersSliceSuccess(response));
  } catch (e: any) {
    dispatch(donationNumbersAction.donationNumbersSliceFailure(e?.response?.data?.message));
    dispatch(donationNumbersAction.donationNumbersSliceReset());
  }
};
export default donationNumbersSlice.reducer;
export const donationNumbersAction = donationNumbersSlice.actions;
